export default "__VITE_ASSET__DFbbm0lS__"